/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";

/** @module react/modules/get-ref-handler */

/**
 * @typedef getRefHandlerRefType
 * @property {*} current - Ref value.
 */

/**
 * @typedef {(null|getRefHandlerRefType|function(getRefHandlerRefType): void)} getRefHandlerRefReceiverType
 */

/**
 * @description Utility function for components ref handling.
 * @param {getRefHandlerRefReceiverType} forwardedRef - Forwarded ref.
 * @param {getRefHandlerRefReceiverType} componentRef - Local ref.
 * @returns {function(getRefHandlerRefType): void} Ref handler.
 */
function getRefHandler(forwardedRef, componentRef) {
  var _this = this,
      _context;

  /**
   * @description Apply ref to receiver.
   * @param {getRefHandlerRefType} ref - Ref.
   * @param {getRefHandlerRefReceiverType} refReceiver - Ref receiver.
   * @returns {void} Void.
   */
  var applyRef = function applyRef(ref, refReceiver) {
    if (typeof refReceiver === 'function') {
      refReceiver(ref);
    } else if (_typeof(refReceiver) === 'object' && refReceiver !== null && !_Array$isArray(refReceiver)) {
      refReceiver.current = ref;
    }
  };

  return _bindInstanceProperty(_context = function _context(ref) {
    _newArrowCheck(this, _this);

    applyRef(ref, forwardedRef);
    applyRef(ref, componentRef);
  }).call(_context, this);
}

export { getRefHandler };